import React from 'react';
import { useTranslation } from 'react-i18next';

const AppCheckbox = ({label, name, onChange, checked = false, ...props}) => {

    const { t } = useTranslation();
    return (
        <div className="fancy-checkbox">
            <label>
                <input
                    name={name}
                    type="checkbox"
                    checked={checked}
                    onChange={onChange}
                />
                <span>{typeof label === 'string' ? t(label) : label}</span>
            </label>
        </div>
    )

}

export default AppCheckbox;